var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Textfield } from "syf-component-library/ui/atoms";
import { Stack } from "syf-component-library/ui/spacing";
import idPrefix from "../../../../const/idPrefix";
import { useEditProfileContext } from "../../../../context/editProfileContext";
import checkIsTablet from "../../../../helpers/checkIsTablet";
import ProfileRow from "../../../molecules/ProfileRow";
import { RowInput } from "../../../subcomponents";
import getTranslation from "../../../../strings/getTranslations";
var EmailSection = function () {
    var t = getTranslation().t;
    var isTablet = useEditProfileContext().isTablet;
    var _a = useFormContext(), control = _a.control, isSubmitting = _a.formState.isSubmitting;
    return (_jsx(ProfileRow, __assign({ title: t("labels.email") }, { children: _jsxs(RowInput, __assign({ "data-private": true }, { children: [_jsx(Stack, { size: "medium" }), _jsx(Controller, { name: "emailAddress", control: control, render: function (_a) {
                        var _b = _a.field, name = _b.name, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, error = _a.fieldState.error;
                        return (_jsx(Textfield, { id: idPrefix("email-address"), name: name, type: "text", width: checkIsTablet(isTablet, "477px"), placeholder: t("labels.email"), error: t((error === null || error === void 0 ? void 0 : error.message) || ""), isDisabled: isSubmitting, onChange: onChange, onBlur: onBlur, value: value, maxLength: 50 }));
                    } }), _jsx(Stack, { size: "medium" })] })) })));
};
export default EmailSection;
